/**
 * Build verification — reads the canonical build markers from the
 * static `<meta>` tags injected into `public/index.html`.
 *
 *   Single source of truth:  `public/index.html`
 *     ↓
 *   exposed here as JS constants
 *     ↓
 *   rendered in `SiteFooter` (visible) AND already in the raw HTML
 *   that `curl https://app.inter-view.ca/ | grep app-version` returns.
 *
 * Bumping the version is therefore a one-line change to
 * `public/index.html` — zero drift, no duplication.
 */

function readMeta(name, fallback) {
  if (typeof document === "undefined") return fallback;
  const el = document.querySelector(`meta[name="${name}"]`);
  return (el && el.getAttribute("content")) || fallback;
}

export const APP_VERSION = readMeta("app-version", "dev");
export const APP_BUILD_DATE = readMeta("app-build-date", "");
